/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class TaskExecLogMaterialItem extends Component {
  render() {
    if (this.props.materialItem.status === 2) {
      return (
        <div className="thumbnail thumbnail_no-padding bdrs-0 thumbnail_inline-block thumbnail_fix-size">
          <span
            className="img-fill"
            style={{
              textAlign: 'center',
              fontSize: '70px',
              color: '#eaeaea'
            }}
            title="Перемещен в архив по сроку давности"
          >
            <i className="fa fa-picture-o" aria-hidden="true" />
          </span>
        </div>
      );
    }
    const button = `<a class="btn btn-muted" style="float: right;" onclick="forceDownload('${this.props.materialItem.fileUrl}', 'exec-${this.props.materialItem.taskExecId}-${this.props.materialItem.fileName}');" target="_blank" type="button"><i class="fa fa-download" /> Скачать</a>`;
    return (
      <div className="thumbnail thumbnail_no-padding bdrs-0 thumbnail_inline-block thumbnail_fix-size">
        {this.props.materialItem.fileName.match(/.(jpg|jpeg|png|gif)$/i) ? (
          <a
            className="img-fill"
            data-gallery="gallery-demo"
            data-title="Просмотр фотографии"
            data-toggle="lightbox"
            data-footer={button}
            href={this.props.materialItem.fileUrl}
            style={{
              backgroundImage: `url("${this.props.materialItem.filePreviewUrl}")`
            }}
          />
        ) : (
          <a
            className="img-fill"
            href={this.props.materialItem.fileUrl}
            style={{
              textAlign: 'center',
              fontSize: '23px',
              paddingTop: '34px'
            }}
            download={this.props.materialItem.fileName}
            rel="noopener noreferrer"
            target="_blank"
          >
            .{this.props.materialItem.fileName.split('.').pop()}{' '}
            <i className="fa fa-download" aria-hidden="true" />
          </a>
        )}
      </div>
    );
  }
}

TaskExecLogMaterialItem.propTypes = {
  materialItem: PropTypes.shape({
    fileName: PropTypes.string.isRequired,
    filePreviewUrl: PropTypes.string.isRequired,
    fileUrl: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    taskExecId: PropTypes.number.isRequired
  }).isRequired
};

export default TaskExecLogMaterialItem;



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLogItem/items/TaskExecLogMaterialItem.js